<div class="container">
  <div class="column-border"></div>
  <mat-toolbar color="primary" class="toolbar-over-card">
    <div>Server Configuration</div>
    <div style="box-sizing: border-box; display: flex; place-content: flex-end space-between; align-items: flex-end;">
      <span class="search-control">
        <mat-form-field *ngIf="isSearch" class="custom-form-field-placeholder-colors">
          <input matInput type="text" #searchBox [formControl]="searchControl" name="searchString" placeholder="Search for config" autofocus />
          <button mat-button *ngIf="searchControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="searchControl.reset()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <button mat-icon-button (click)="showSearch()">
          <mat-icon>search</mat-icon>
        </button>
      </span>
      <button mat-icon-button routerLink="/platform/activity">
        <span class="fal fa-chart-network"></span>
      </button>
    </div>
  </mat-toolbar>

  <mat-card appearance="outlined" class="scrollable-content">
    <mat-card-content>
      <div *ngFor="let config of filteredConfigs$ | async" class="inserted-row">
        <lex-server-config-item [config]="config"
                                [actionNotifier]="buttonClickSubject.asObservable()"
                                (valueChange)="dirty=true">
        </lex-server-config-item>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <button mat-button color="primary" (click)="saveAll()" [disabled]="!dirty">Save</button>
      <button mat-button color="primary" (click)="cancelAll()" [disabled]="!dirty">Cancel</button>
    </mat-card-actions>
  </mat-card>
  <div class="column-border"></div>
</div>
